module.exports = __webpack_public_path__ + "static/media/Westwood.a6c05d9a.mp4";